// extracted by mini-css-extract-plugin
export default {"isVertical":"BigVerticalRadioList_isVertical__D6Vtp"};